export default __webpack_public_path__ + "4fd1608ef3fe5bae60456552c9f98827.jpg";